var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8333 4C26.5406 4 27.2189 4.28095 27.719 4.78105C28.219 5.28115 28.5 5.95942 28.5 6.66667V25.3333C28.5 26.0406 28.219 26.7189 27.719 27.219C27.2189 27.719 26.5406 28 25.8333 28H7.16667C6.45942 28 5.78115 27.719 5.28105 27.219C4.78095 26.7189 4.5 26.0406 4.5 25.3333V6.66667C4.5 5.95942 4.78095 5.28115 5.28105 4.78105C5.78115 4.28095 6.45942 4 7.16667 4H25.8333ZM25.1667 24.6667V17.6C25.1667 16.4472 24.7087 15.3416 23.8936 14.5264C23.0784 13.7113 21.9728 13.2533 20.82 13.2533C19.6867 13.2533 18.3667 13.9467 17.7267 14.9867V13.5067H14.0067V24.6667H17.7267V18.0933C17.7267 17.0667 18.5533 16.2267 19.58 16.2267C20.0751 16.2267 20.5499 16.4233 20.8999 16.7734C21.25 17.1235 21.4467 17.5983 21.4467 18.0933V24.6667H25.1667ZM9.67333 11.4133C10.2674 11.4133 10.8372 11.1773 11.2573 10.7573C11.6773 10.3372 11.9133 9.76742 11.9133 9.17333C11.9133 7.93333 10.9133 6.92 9.67333 6.92C9.07571 6.92 8.50257 7.1574 8.07999 7.57999C7.6574 8.00257 7.42 8.57571 7.42 9.17333C7.42 10.4133 8.43333 11.4133 9.67333 11.4133ZM11.5267 24.6667V13.5067H7.83333V24.6667H11.5267Z",
    fill: "#110E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bbd351960dcc17121dd7940924ba2828.svg";
export { ForwardRef as ReactComponent };